import { render } from "./Pricelist.vue?vue&type=template&id=a7cf85d0"
const script = {}

import exportComponent from "C:\\Users\\zelen\\Documents\\dev\\osobni\\finestudio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__